var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { RouterType } from '../propTypes';
import cx from 'classnames';
import qs from 'querystring';

var Link = function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (evt) {
      var _this$props = _this.props,
          to = _this$props.to,
          target = _this$props.target,
          onClick = _this$props.onClick;
      onClick && onClick(evt); // Taken from react-router to match their Link logic

      if (!evt.defaultPrevented && // onClick prevented default
      evt.button === 0 && // ignore everything but left clicks
      target == null && // let browser handle "target=_blank" etc.
      !isModifiedEvent(evt) // ignore clicks with modifier keys
      ) {
          evt.preventDefault();

          _this.context.router.push(to);
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var router = this.context.router;

      var _props = this.props,
          to = _props.to,
          className = _props.className,
          activeClassName = _props.activeClassName,
          style = _props.style,
          children = _props.children,
          exact = _props.exact,
          onClick = _props.onClick,
          rest = _objectWithoutProperties(_props, ['to', 'className', 'activeClassName', 'style', 'children', 'exact', 'onClick']);

      var href = (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? locationToHref(to) : to;
      var matchPrefix = '^';
      var matchSuffix = '/?' + (exact === true ? '$' : '');
      var matcher = new RegExp('' + matchPrefix + (typeof href === 'string' ? href.replace(/(\?.*)?$/, '') : '') + matchSuffix);
      var isActive = matcher.test(this.context.router._store.location.pathname);
      return React.createElement('a', _extends({
        href: href != null ? router.createHref(href) : null,
        className: cx(className, typeof activeClassName === 'string' && _defineProperty({}, activeClassName, isActive)),
        style: style,
        onClick: this.onClick
      }, rest), children);
    }
  }]);

  return Link;
}(Component);

Link.contextTypes = {
  router: RouterType
};

var locationToHref = function locationToHref(location) {
  var queryString = qs.stringify(location.query);
  var hash = location.hash || '';
  var search = (queryString ? '?' + queryString : location.search) || '';
  return '' + location.pathname + hash + search;
};

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

export default observer(Link);